/* eslint-disable react/require-default-props */
import { useEffect } from 'react';
import { Outlet, useNavigate, useSearchParams } from "react-router-dom"
import Container from '@mui/material/Container';
import { URL_PARAMS, DISP_MODE } from '../../../constants/constants'
import EquipmentFuncTab from '../components/EquipmentFuncTab';
import { DataStoreContextProvider } from "../contexts/EquipmentContext";
import { ROLE_KEYS, useUserRole } from '../../../utils/awsConfigure';

export default function EquipmentLayout() {
  const { userRole } = useUserRole();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isPopupMode = !!(searchParams.get(URL_PARAMS.DISP_MODE) && searchParams.get(URL_PARAMS.DISP_MODE) === DISP_MODE.POPUP);

  useEffect(()=>{
    if(userRole===ROLE_KEYS.RETAILER){
      navigate("/");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  return (
    <DataStoreContextProvider>
      { !isPopupMode &&
        <EquipmentFuncTab />
      }
      <Container sx={{
        mx:0, pb:3, pt:0, width:"100%", backgroundColor: 'white', maxWidth:"unset!important",
        ...(isPopupMode ? {p : "0 !important"} : {}) }}>
        <Container sx={{mx:0, pb:3, pt:1, width:"100%", backgroundColor: '#F6F7F8', maxWidth:"unset!important"}}>
          <Outlet />
        </Container>
      </Container>
    </DataStoreContextProvider>
  )
}
